import { useState } from 'react';
import { submitEvaluation } from '../../services/evaluationService';
import PunishmentModal from '../Punishmentmodal/Punishmentmodal';
import './EvaluationModal.scss';

const IconStar = ({ filled, onClick, onMouseEnter, onMouseLeave }) => (
  <svg
    width="32" height="32" viewBox="0 0 24 24"
    fill={filled ? '#f59e0b' : 'none'}
    stroke="#f59e0b" strokeWidth="1.5"
    onClick={onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}
    style={{ cursor: 'pointer' }}
  >
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
);

export default function EvaluationModal({
  jobApplicationId,
  evaluatorId,
  freelancerId,    // necessário apenas para o PunishmentModal
  targetName,
  targetAvatar,
  onClose,
  onSubmitted,
}) {
  const isCompany = localStorage.getItem("userType") === "Company";
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [comment, setComment] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPunishment, setShowPunishment] = useState(false);

  const handleSubmit = async () => {
    if (rating === 0) { setError('Selecione uma nota de 1 a 5 estrelas.'); return; }
    setLoading(true);
    setError('');
    try {
      // EvaluationModal.jsx — handleSubmit
      await submitEvaluation(jobApplicationId, rating, comment.trim() || null);
      onSubmitted?.();
      onClose();
    } catch (err) {
      const msg = err?.response?.data || 'Erro ao enviar avaliação.';
      setError(typeof msg === 'string' ? msg : 'Erro ao enviar avaliação.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div
        className={`evm-overlay ${showPunishment ? 'evm-overlay--disabled' : ''}`}
        onClick={(e) => {
          if (e.target === e.currentTarget) onClose();
        }}
      >
        <div className="evm-modal" onClick={(e) => e.stopPropagation()}>

          <div className="evm-header">
            {targetAvatar ? (
              <img src={targetAvatar} alt={targetName} className="evm-avatar" />
            ) : (
              <div className="evm-avatar-fallback">{targetName?.slice(0, 2).toUpperCase()}</div>
            )}
            <h3 className="evm-title">Como foi trabalhar com {targetName}?</h3>
            <p className="evm-subtitle">Sua avaliação ajuda a manter a qualidade da plataforma.</p>
          </div>

          <div className="evm-stars">
            {[1, 2, 3, 4, 5].map((star) => (
              <IconStar
                key={star}
                filled={star <= (hover || rating)}
                onClick={() => setRating(star)}
                onMouseEnter={() => setHover(star)}
                onMouseLeave={() => setHover(0)}
              />
            ))}
          </div>

          <textarea
            className="evm-textarea"
            placeholder="Comentário (opcional)"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            rows={3}
            maxLength={300}
            disabled={loading}
          />

          {error && <p className="evm-error">{error}</p>}

          <div className="evm-actions">
            <button className="evm-btn evm-btn--skip" onClick={onClose} disabled={loading}>
              Agora não
            </button>
            <button className="evm-btn evm-btn--submit" onClick={handleSubmit} disabled={loading}>
              {loading ? 'Enviando...' : 'Enviar avaliação'}
            </button>
          </div>
          {/* 
          {isCompany && (
            <div className="evm-report">
              <button className="evm-report-btn" onClick={() => setShowPunishment(true)}>
                ⚠️ Relatar problema com este freelancer
              </button>
            </div>
          )} */}

        </div>
      </div>

      {showPunishment && (
        <PunishmentModal
          freelancerId={freelancerId}
          companyId={evaluatorId}
          freelancerName={targetName}
          jobApplicationId={jobApplicationId}
          onClose={() => setShowPunishment(false)}
          onSubmitted={() => setShowPunishment(false)}
        />
      )}
    </>
  );
}